import React from 'react';
import NavBar from '../../components/Navbar/NavBar';
import Footer from '../../components/Footer';
import Card from '../../components/Cards/Card';
import artisticProgram from '../../data/artisticProgram/artisticProgram';
import useDocTitle from '../../utils/useDocTitle';
import SideMenu from '../../components/SideMenu';

const Exhibitions = () => {
  useDocTitle('Exhibitions');

  const menuItems = [
    { href: '#overview', label: 'Përmbledhje' },
    { href: '#exhibitions', label: 'Ekspozitat' },
  ];

  return (
    <>
      <NavBar />

      <div className="relative w-full h-96 bg-cover bg-center flex items-center justify-center"
           style={{
             backgroundImage: `url(/images/main/giulia%20dajci%20photo%202.jpg)`,
             backgroundPosition: 'center',
             backgroundSize: 'cover',
             height: '550px',
           }}
           role="img"
           aria-label="Background image for Exhibitions section"
      >
        <div className="absolute inset-0 bg-black opacity-60"></div>
        <div className="relative z-10 text-center text-white">
          <h1 className="text-5xl font-bold" tabIndex="0">Ekspozitat</h1>
        </div>
      </div>

      <div className="flex min-h-screen">
        <aside className="w-1/4 bg-gray-100 px-8 py-12 sticky top-16 h-screen" aria-label="Sidebar navigation for Exhibitions">
          <SideMenu
            backLink="/artistic-program"
            backText="PROGRAMET ARTISTIKE"
            menuItems={menuItems}
          />
        </aside>

        <div className="w-3/4 py-12 px-6">
          <div id="overview" className="container-inner mb-12">
            <h2 className="text-3xl font-semibold mb-6" tabIndex="0">Përmbledhje</h2>
          </div>

          <div id="exhibitions" className="container-inner mb-12">
            <h2 className="text-3xl font-semibold mb-6" tabIndex="0">Ekspozitat</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {artisticProgram.exhibitions.map((program) => (
                <Card
                  key={program.id}
                  id={program.id}
                  title={program.title}
                  description={program.description}
                  imgSrc={program.imgSrc}
                  imgAlt={program.imgAlt}
                  linkText={program.linkText}
                  linkPath={`/resources/exhibitions/${program.id}`}
                  borderColorClass="border-primary"
                  ariaLabel={`Go to exhibition ${program.title}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Exhibitions;